module.exports = __webpack_public_path__ + "images/paypal-foto-bkg.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/paypal-foto-bkg.png
 ** module id = 29
 ** module chunks = 0
 **/